<div class="field-unit">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center"
      (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>

    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'"
      class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="item"
        style="display: flex; justify-content: space-between; gap: 5px; align-items: center; line-height: normal;">
        <p>{{ 'thiet_ke_nut_khi' | translate }}:&nbsp;{{ (!objectChoosing.isActive ? 'chua_kich_hoat' : 'kich_hoat') |
          translate}}</p>
        <nz-switch class="ml-3" [(ngModel)]="objectChoosing.isActive"></nz-switch>
      </div>

      <nz-radio-group style="display: flex;align-items: center;flex-wrap: wrap; gap: 20px; padding:10px 5px;"
        [(ngModel)]="config.units_type">
        <label *ngFor="let tab of tabs; let i = index" (click)="chooseUnits(i)" nz-radio [nzValue]="i">{{tab |
          translate}}</label>
      </nz-radio-group>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <div class="item"
      style="display: flex; justify-content: space-between; gap: 5px; align-items: center; line-height: normal;">
      <p>{{ ('thiet_ke_nut_khi_' + (!objectChoosing.isActive ? 'chua_kich_hoat' : 'kich_hoat')) | translate }}</p>
      <nz-switch class="ml-3" [(ngModel)]="objectChoosing.isActive"></nz-switch>
    </div>

    <ul nz-menu nzMode="inline" *ngIf="!isViewAll">
      <!-- CẤU HÌNH GIAO DIỆN -->
      <li nz-submenu nzTitle="{{'giao_dien'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <nz-radio-group style="display: flex;align-items: center;flex-wrap: wrap; gap: 20px; padding:10px 5px;"
          [(ngModel)]="config.units_type">
          <label *ngFor="let tab of tabs; let i = index" (click)="chooseUnits(i)" nz-radio [nzValue]="i">{{tab |
            translate}}</label>
        </nz-radio-group>
      </li>

      <!-- CẤU HÌNH VỊ TRÍ -->
      <li nz-submenu nzTitle="{{'vi_tri'| translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="position">
          <div class="position-unit">
            <p style="font-weight: 500;">{{'huong' | translate}}</p>
            <nz-radio-group class="position-option" [(ngModel)]="class['units__container']['flex-direction']"
              (ngModelChange)="updateObject()">
              <label nz-radio nzValue="row"><span>{{'ngang' | translate}}</span></label>
              <label nz-radio nzValue="column"><span>{{'doc' | translate}}</span></label>
            </nz-radio-group>
          </div>
          <div class="position-unit"
            style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
            <p class="m-0 title" style="line-height: 1.5;">{{'khoang_cach_giua_cac_don_vi' | translate}} </p>
            <nz-input-number [ngModel]="class['units__container']['gap'] | vhnumber" name="type-1-gap"
              (ngModelChange)="class['units__container']['gap'] = $event + 'px'"
              (nzBlur)="updateObject()"></nz-input-number>
          </div>
          <nz-slider [ngModel]="class['units__container']['gap'] | vhnumber" style="padding: 5px;"
            (ngModelChange)="class['units__container']['gap'] = $event + 'px'" (nzOnAfterChange)="updateObject()">
          </nz-slider>
        </div>
        <div *ngIf="class['units__container']['flex-direction'] == 'row'"
          class="d-flex justify-content-between align-items-center">
          <span style="line-height: 1.4;">{{ 'xuong_dong' | translate }}</span>
          <nz-switch [ngModel]="class['units__container']['flex-wrap'] == 'wrap'"
            (ngModelChange)="
              class['units__container']['flex-wrap'] = $event ? 'wrap' : 'nowrap'; updateObject()
            ">
          </nz-switch>
        </div>
      </li>
    </ul>

    <!-- CẤU HÌNH CỦA KIỂU 1 -->
    <div class="config-unit" *ngIf="config.units_type == 0">
      <ul nz-menu nzMode="inline" *ngIf="!isViewAll">
        <!-- CẤU HÌNH Chữ và màu nền -->
        <li nz-submenu [nzTitle]="'chu_va_mau_nen' | translate" [(nzOpen)]="openMap.menu3"
          (nzOpenChange)="openHandler('menu3')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-family']"
                    [(value)]="class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}}</mat-label>
                  <input type="number" matInput
                    [ngModel]="class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-size'] | vhnumber"
                    name="type1-font-size" (ngModelChange)="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-size'] =
                    $event + 'px'; updateObject()
                " />
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-weight'] == 'bold'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-weight'] =
                    class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-weight'] == 'bold'
                      ? '500'
                      : 'bold';
                  updateObject()
                ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-style'] == 'italic'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-style'] =
                    class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['font-style'] == 'normal'
                      ? 'italic'
                      : 'normal';
                  updateObject()
                ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['text-decoration'] ==
                  'underline'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['text-decoration'] =
                    class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['text-decoration'] ==
                    'none'
                      ? 'underline'
                      : 'none';
                  updateObject()
                ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['text-transform'] ==
                  'uppercase'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['text-transform'] =
                    class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content']['text-transform'] ==
                    'none'
                      ? 'uppercase'
                      : 'none';
                  updateObject()
                ">
                  <span>AB</span>
                </button>
                <!-- Màu chữ -->
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content'].color"
                    [style.background]="class[ objectChoosing.isActive ? '+units__items--content' :  '-units__items--content'].color"
                    (colorPickerClose)="updateObject()" name="type1-color" [cpWidth]="'230px'"
                    [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <!-- Màu nền -->
            <div class="color-pick">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class[ objectChoosing.isActive ? '+units__items' : '-units__items']['background-color']"
                [style.background]="class[ objectChoosing.isActive ? '+units__items' : '-units__items']['background-color']"
                (colorPickerClose)="updateObject()" name="type1-background-color" [cpWidth]="'230px'" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- CẤU HÌNH CỦA KIỂU 1 -->

    <!-- CÂU HÌNH CỦA KIỂU 2 -->
    <div class="config-unit" *ngIf="config.units_type == 1">
      <ul nz-menu nzMode="inline" *ngIf="!isViewAll">
        <!-- CẤU HÌNH Chữ và màu nền -->
        <li nz-submenu [nzTitle]="'chu_va_mau_nen' | translate" [(nzOpen)]="openMap.menu3"
          (nzOpenChange)="openHandler('menu3')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-family']"
                    [(value)]="class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}}</mat-label>

                  <input type="number" matInput
                    [ngModel]="class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-size'] | vhnumber"
                    (ngModelChange)="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-size'] =
                    $event + 'px'; updateObject()
                " />
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-weight'] == 'bold'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-weight'] =
                    class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-weight'] == 'bold'
                      ? '500'
                      : 'bold';
                  updateObject()
                ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-style'] == 'italic'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-style'] =
                    class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['font-style'] == 'normal'
                      ? 'italic'
                      : 'normal';
                  updateObject()
                ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['text-decoration'] ==
                  'underline'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['text-decoration'] =
                    class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['text-decoration'] ==
                    'none'
                      ? 'underline'
                      : 'none';
                  updateObject()
                ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['text-transform'] ==
                  'uppercase'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['text-transform'] =
                    class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content']['text-transform'] ==
                    'none'
                      ? 'uppercase'
                      : 'none';
                  updateObject()
                ">
                  <span>AB</span>
                </button>
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content'].color"
                    [style.background]="class[ objectChoosing.isActive ? '+units-radio__items--content' : '-units-radio__items--content'].color"
                    (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="field-row-text">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class[objectChoosing.isActive ? '+units-radio__items' : '-units-radio__items']['background-color']"
                  [style.background]="class[objectChoosing.isActive ? '+units-radio__items' : '-units-radio__items']['background-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
              </div>
            </div>

            <div class="field-row-text" *ngIf="objectChoosing.isActive">
              <p class="m-0 title w-50">{{'mau_nut' | translate}}</p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['-units-radio__items--input']['accent-color']"
                  [style.background]="class['-units-radio__items--input']['accent-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- CÂU HÌNH CỦA KIỂU 2 -->

    <!-- CẤU HÌNH CỦA KIỂU 3 -->
    <div class="config-unit" *ngIf="config.units_type == 2">
      <ul nz-menu nzMode="inline" *ngIf="!isViewAll">
        <!-- CẤU HÌNH Chữ và màu nền -->
        <li nz-submenu [nzTitle]="'chu_va_mau_nen' | translate" [(nzOpen)]="openMap.menu3"
          (nzOpenChange)="openHandler('menu3')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-family']"
                    [(value)]="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}} </mat-label>
                  <input type="number" matInput
                    [ngModel]="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-size'] | vhnumber"
                    (ngModelChange)="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-size'] = $event + 'px'; updateObject()"
                    [value]="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-size'] | vhnumber">
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-weight'] == 'bold'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-weight'] =
                    class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-weight'] == 'bold'
                      ? '500'
                      : 'bold';
                  updateObject()
                ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-style'] == 'italic'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-style'] =
                    class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['font-style'] == 'normal'
                      ? 'italic'
                      : 'normal';
                  updateObject()
                ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['text-decoration'] ==
                  'underline'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['text-decoration'] =
                    class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['text-decoration'] ==
                    'none'
                      ? 'underline'
                      : 'none';
                  updateObject()
                ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['text-transform'] ==
                  'uppercase'
                    ? 'primary'
                    : 'default'
                " (click)="
                  class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['text-transform'] =
                    class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content']['text-transform'] ==
                    'none'
                      ? 'uppercase'
                      : 'none';
                  updateObject()
                ">
                  <span>AB</span>
                </button>
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content'].color"
                    [style.background]="class[ objectChoosing.isActive ? '+units-check__items--content' : '-units-check__items--content'].color"
                    (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="field-row-text">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>

              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class[ objectChoosing.isActive ? '+units-check__items' : '-units-check__items']['background-color']"
                [style.background]="class[ objectChoosing.isActive ? '+units-check__items' : '-units-check__items']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
            </div>
            <!-- Màu dấu check -->
            <div class="field-row-text" *ngIf="objectChoosing.isActive">
              <p class="m-0 title w-50" style="line-height: normal;">{{'mau_dau_check' | translate}}</p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['+units-check__items--after']['color']"
                  [style.background]="class['+units-check__items--after']['color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" />
              </div>
            </div>

            <!-- Màu nền check -->
            <div class="field-row-text" *ngIf="objectChoosing.isActive">
              <p class="m-0 title w-50" style="line-height: normal;">{{'mau_nen_dau_check' | translate}} </p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['+units-check__items--before']['border-top-color']"
                  [style.background]="class['+units-check__items--before']['border-top-color']"
                  (colorPickerClose)="updateObject();updateBorderColor()" [cpWidth]="'230px'" />
              </div>
            </div>

          </div>
        </li>
      </ul>
    </div>

    <ul nz-menu nzMode="inline" *ngIf="!isViewAll">
      <!-- CẤU HÌNH hình ảnh -->
      <li nz-submenu [nzTitle]="'hinh_anh' | translate" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div class="mt-1 d-flex align-items-center justify-content-between">
          <p style="font-weight: 500; line-height: 1.4; width: 70%">
            {{'anh_sub_hien_thi_len_nhom_anh_khi_chon_sub' | translate}}
          </p>
          <nz-switch [ngModel]="config.is_img_sub_show_image_detail"
            (ngModelChange)="config.is_img_sub_show_image_detail = $event; updateObject()">
          </nz-switch>
        </div>
        <div class="mt-2 d-flex align-items-center justify-content-between">
          <p style="font-weight: 500; line-height: 1.4;">
            {{'hien_thi_anh_sub' | translate}}
          </p>
          <nz-switch [ngModel]="config[(objectChoosing.isActive ? '+' : '-') + 'is_img_sub']"
            (ngModelChange)="config[(objectChoosing.isActive ? '+' : '-') + 'is_img_sub'] = $event; updateObject()">
          </nz-switch>
        </div>
        <ng-container *ngIf="config[(objectChoosing.isActive ? '+' : '-') + 'is_img_sub']">
          <div class="mt-2 d-flex align-items-center justify-content-between">
            <p style="font-weight: 500; line-height: 1.4;">
              {{'chieu_rong' | translate}}
            </p>
            <nz-input-number [nzMin]="10" [nzMax]="100" [nzStep]="1"
              [ngModel]="(class[(objectChoosing.isActive ? '+' : '-') + 'units__items--img']?.['width'] || '40px') | vhnumber"
              (ngModelChange)="updateImgSub($event, 'width', 'px', false)"
              (nzBlur)="updateObject()"></nz-input-number>
          </div>
          <div class="mt-2 d-flex align-items-center justify-content-between">
            <p style="font-weight: 500; line-height: 1.4;">
              {{'chieu_cao' | translate}}
            </p>
            <nz-input-number [nzMin]="10" [nzMax]="100" [nzStep]="1"
              [ngModel]="(class[(objectChoosing.isActive ? '+' : '-') + 'units__items--img']?.['height'] || '40px') | vhnumber"
              (ngModelChange)="updateImgSub($event, 'height', 'px', false)"
              (nzBlur)="updateObject()"></nz-input-number>
          </div>
          <div class="mt-2 d-flex align-items-center justify-content-between">
            <p style="font-weight: 500; line-height: 1.4;">
              {{'bao_phu' | translate}}
            </p>
            <nz-select
              [ngModel]="class[(objectChoosing.isActive ? '+' : '-') + 'units__items--img']?.['object-fit'] || 'contain'"
              (ngModelChange)="updateImgSub($event, 'object-fit')">
              <nz-option [nzValue]="'none'" [nzLabel]="'khong_co' | translate"></nz-option>
              <nz-option [nzValue]="'cover'" [nzLabel]="'phu_kin' | translate"></nz-option>
              <nz-option [nzValue]="'contain'" [nzLabel]="'giu_ty_le' | translate"></nz-option>
              <nz-option [nzValue]="'fill'" [nzLabel]="'lap_day' | translate"></nz-option>
            </nz-select>
          </div>
          <div class="mt-2 d-flex align-items-center justify-content-between">
            <p style="font-weight: 500; line-height: 1.4; width: 50%">
              {{'khoang_cach_giua_hinh_va_noi_dung' | translate}}
            </p>
            <nz-input-number
              [ngModel]="(class[(objectChoosing.isActive ? '+' : '-') + 'units__items']?.['gap'] || '0px') | vhnumber"
              (ngModelChange)="updateImgSub($event, 'gap', 'px', false)"
              (nzBlur)="updateObject()"></nz-input-number>
          </div>
        </ng-container>
      </li>

      <!-- CẤU HÌNH ĐỊNH DẠNG VIỀN -->
      <li nz-submenu [nzTitle]="'vien' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-borders-config [device]="device" [class]="class"
          [borderClass]="class[ objectChoosing.isActive ? '+units-check__items' : '-units-check__items']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[2])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- CẤU HÌNH HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
    </ul>

    <!-- Xem chi tiết cấu hình object -->
    <div class="view-more" *ngIf="isViewAll">
      <!-- Cấu hình chi tiết viền -->
      <div class="view_more-border" *ngIf="[1, 2, 3].includes(currentViewAll.index)">
        <app-borders-radius-config [device]="device" [class]="class"
          [borderRadiusClass]="class[objectChoosing.isActive ? '+units-check__items' : '-units-check__items']"
          [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </div>
    </div>
  </ng-container>
</div>